import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

export default {
  state: {
    tags: [],
    loading: false,
    error: false,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorTags(state) {
      state.tags = [];
      state.loading = false;
      state.error = true;
    },
    setTags(state, tags) {
      state.tags = tags;
      state.loading = false;
      state.error = false;
    },
  },
  actions: {
    async fetchTags({ commit }) {
      commit('fetch');
      try {
        const response = await backend.getTags();
        await checkResponseStatus(200, response);
        const json = response.data;
        commit('setTags', json);
      } catch (error) {
        console.error(error);
        commit('errorTags');
      }
    },
    async createTag(context, { tag }) {
      const response = await backend.postTag(tag);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async deleteTag(context, { tagID }) {
      const response = await backend.deleteTag(tagID);
      await checkResponseStatus(204, response);
    },
  },
  namespaced: true,
};
